import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'remember-partial',
  templateUrl: './remember-partial.component.html',
  styleUrls: ['./remember-partial.component.scss']
})
export class RememberPartialComponent {

}
